/**
 * A global namespace for `dragover` event.
 */
const dragoverEvent = 'dragover';
export default dragoverEvent;
